var map = {
	"./blue/five/amburger_no.png": "9b99",
	"./blue/five/amburger_yes.png": "1773",
	"./blue/five/duvdevan_no.png": "d357",
	"./blue/five/duvdevan_yes.png": "2620",
	"./blue/five/hanuka_no.png": "1b90",
	"./blue/five/hanuka_yes.png": "9dc2",
	"./blue/five/hipushit_no.png": "d3e9",
	"./blue/five/hipushit_yes.png": "dad5",
	"./blue/five/meshulash_no.png": "5938",
	"./blue/five/meshulash_yes.png": "a93b",
	"./blue/five/patuah_no.png": "68ec",
	"./blue/five/patuah_yes.png": "7fdc",
	"./blue/five/sukarya_no.png": "be2f",
	"./blue/five/sukarya_yes.png": "d257",
	"./blue/five/tapuah_no.png": "5cf7",
	"./blue/five/tapuah_yes.png": "c076",
	"./blue/five/ugyot_no.png": "e107",
	"./blue/five/ugyot_yes.png": "e6ce",
	"./blue/four/buba_no.png": "cf32",
	"./blue/four/buba_yes.png": "4f15",
	"./blue/four/dubi_no.png": "0ada",
	"./blue/four/dubi_yes.png": "dde0",
	"./blue/four/hatul_no.png": "3461",
	"./blue/four/hatul_yes.png": "1680",
	"./blue/four/hultza_no.png": "9f37",
	"./blue/four/hultza_yes.png": "16b0",
	"./blue/four/luach_no.png": "f988",
	"./blue/four/luach_yes.png": "675e",
	"./blue/four/ruach_no.png": "44de",
	"./blue/four/ruach_yes.png": "f26d",
	"./blue/four/sukar_no.png": "1f95",
	"./blue/four/sukar_yes.png": "34d2",
	"./blue/four/sulam_no.png": "2564",
	"./blue/four/sulam_yes.png": "11f8",
	"./blue/four/tuki_no.png": "28d2",
	"./blue/four/tuki_yes.png": "031c",
	"./blue/four/tziyur_no.png": "3cdc",
	"./blue/four/tziyur_yes.png": "7ff6",
	"./blue/level_five.png": "5c67",
	"./blue/level_five_hover.png": "b4b6",
	"./blue/level_five_lock.png": "a648",
	"./blue/level_four.png": "6566",
	"./blue/level_four_hover.png": "cabb",
	"./blue/level_four_lock.png": "920c",
	"./blue/level_one.png": "e56c",
	"./blue/level_one_hover.png": "44c4",
	"./blue/level_six.png": "9757",
	"./blue/level_six_hover.png": "8cd2",
	"./blue/level_six_lock.png": "0b73",
	"./blue/level_three.png": "bef3",
	"./blue/level_three_hover.png": "2605",
	"./blue/level_three_lock.png": "1e07",
	"./blue/level_two.png": "5ab0",
	"./blue/level_two_hover.png": "ae3b",
	"./blue/level_two_lock.png": "c000",
	"./blue/one/U_1.png": "6e55",
	"./blue/one/U_1_correct.png": "cdb7",
	"./blue/one/U_2.png": "2075",
	"./blue/one/U_2_correct.png": "e42d",
	"./blue/one/guide_pic.png": "9ce8",
	"./blue/six/gur_klavim_no.png": "4dd5",
	"./blue/six/gur_klavim_yes.png": "b113",
	"./blue/six/hermon_no.png": "b6f0",
	"./blue/six/hermon_yes.png": "31d4",
	"./blue/six/karish_no.png": "4b3f",
	"./blue/six/karish_yes.png": "fcf1",
	"./blue/six/keytana_no.png": "3b6e",
	"./blue/six/keytana_yes.png": "3ab0",
	"./blue/six/magafaim_no.png": "2535",
	"./blue/six/magafaim_yes.png": "982b",
	"./blue/six/pokeah_eynayim_no.png": "b7b5",
	"./blue/six/pokeah_eynayim_yes.png": "d499",
	"./blue/six/sipur_no.png": "b1bd",
	"./blue/six/sipur_yes.png": "0fee",
	"./blue/six/tzfardea_no.png": "7d0b",
	"./blue/six/tzfardea_yes.png": "f7da",
	"./blue/six/yeled_haham_no.png": "9f58",
	"./blue/six/yeled_haham_yes.png": "a04e",
	"./blue/six/yom_huledet_no.png": "5e5f",
	"./blue/six/yom_huledet_yes.png": "69a7",
	"./blue/three/chum_no.png": "5f71",
	"./blue/three/chum_yes.png": "31f6",
	"./blue/three/hu_no.png": "841c",
	"./blue/three/hu_yes.png": "91a5",
	"./blue/three/hut_no.png": "d9dc",
	"./blue/three/hut_yes.png": "c286",
	"./blue/three/lul_no.png": "fced",
	"./blue/three/lul_yes.png": "23b5",
	"./blue/three/stamp_no.png": "11cb",
	"./blue/three/stamp_yes.png": "2dad",
	"./blue/three/sus_no.png": "a6c0",
	"./blue/three/sus_yes.png": "2eab",
	"./blue/three/tut_no.png": "76c0",
	"./blue/three/tut_yes.png": "49e6",
	"./green/five/afarsek_no.png": "f4fe",
	"./green/five/afarsek_yes.png": "74c1",
	"./green/five/arnevet_no.png": "63c7",
	"./green/five/arnevet_yes.png": "f342",
	"./green/five/haverim_no.png": "8984",
	"./green/five/haverim_yes.png": "6702",
	"./green/five/israel_no.png": "2be2",
	"./green/five/israel_yes.png": "91ee",
	"./green/five/nadneda_no.png": "3d3f",
	"./green/five/nadneda_yes.png": "170e",
	"./green/five/nahlieli_no.png": "b4b0",
	"./green/five/nahlieli_yes.png": "88c1",
	"./green/five/sameah_no.png": "ba9a",
	"./green/five/sameah_yes.png": "5e4d",
	"./green/five/sharsheret_no.png": "7311",
	"./green/five/sharsheret_yes.png": "c061",
	"./green/five/shoteret_no.png": "b228",
	"./green/five/shoteret_yes.png": "0447",
	"./green/five/tv_no.png": "3d67",
	"./green/five/tv_yes.png": "5974",
	"./green/four/arie_no.png": "0584",
	"./green/four/arie_yes.png": "ff76",
	"./green/four/horef_no.png": "0b6f",
	"./green/four/horef_yes.png": "5ab7",
	"./green/four/hosheh_no.png": "1673",
	"./green/four/hosheh_yes.png": "6c30",
	"./green/four/kise_no.png": "280c",
	"./green/four/kise_yes.png": "b2c1",
	"./green/four/mahshev_no.png": "483e",
	"./green/four/mahshev_yes.png": "f757",
	"./green/four/mishmesh_no.png": "676c",
	"./green/four/mishmesh_yes.png": "d8d6",
	"./green/four/namer_no.png": "839f",
	"./green/four/namer_yes.png": "6186",
	"./green/four/perah_no.png": "d52e",
	"./green/four/perah_yes.png": "d3e90",
	"./green/four/pilpel_no.png": "6093",
	"./green/four/pilpel_yes.png": "c423",
	"./green/four/zaken_no.png": "4aed",
	"./green/four/zaken_yes.png": "bc25",
	"./green/level_five.png": "60e6",
	"./green/level_five_hover.png": "6e99",
	"./green/level_five_lock.png": "b37e",
	"./green/level_four.png": "2063",
	"./green/level_four_hover.png": "f2e8",
	"./green/level_four_lock.png": "6536",
	"./green/level_one.png": "e53d8",
	"./green/level_one_hover.png": "d3de",
	"./green/level_six.png": "de5c",
	"./green/level_six_hover.png": "42c3",
	"./green/level_six_lock.png": "559e",
	"./green/level_three.png": "d118",
	"./green/level_three_hover.png": "f449",
	"./green/level_three_lock.png": "b86c",
	"./green/level_two.png": "1c48",
	"./green/level_two_hover.png": "fe27",
	"./green/level_two_lock.png": "73f8",
	"./green/one/E_1.png": "368c",
	"./green/one/E_1_correct.png": "fa3c",
	"./green/one/E_2.png": "f4b2",
	"./green/one/E_2_correct.png": "7b6f",
	"./green/one/guide_pic.png": "7cd7",
	"./green/six/ach_katan_no.png": "2cae",
	"./green/six/ach_katan_yes.png": "c621",
	"./green/six/gamad_matana_no.png": "c02c",
	"./green/six/gamad_matana_yes.png": "8937",
	"./green/six/gan_rina_no.png": "15f4",
	"./green/six/gan_rina_yes.png": "bf55",
	"./green/six/gorila_no.png": "952c",
	"./green/six/gorila_yes.png": "4118",
	"./green/six/halalit_bereshit_no.png": "9dc4",
	"./green/six/halalit_bereshit_yes.png": "4dda",
	"./green/six/kelev_bachatzer_no.png": "7206",
	"./green/six/kelev_bachatzer_yes.png": "929c",
	"./green/six/lilbosh_meil_no.png": "7aa4",
	"./green/six/lilbosh_meil_yes.png": "2922",
	"./green/six/tovim_hashnaim_no.png": "6cde",
	"./green/six/tovim_hashnaim_yes.png": "fc0a",
	"./green/six/tzfardea_no.png": "21f6",
	"./green/six/tzfardea_yes.png": "6f25",
	"./green/three/ben_no.png": "14e8",
	"./green/three/ben_yes.png": "bb04",
	"./green/three/en_no.png": "b450",
	"./green/three/en_yes.png": "5d58",
	"./green/three/esh_no.png": "9629",
	"./green/three/esh_yes.png": "4b85",
	"./green/three/et_no.png": "49bc",
	"./green/three/et_yes.png": "66d2",
	"./green/three/ez_no.png": "1172",
	"./green/three/ez_yes.png": "0389",
	"./green/three/ken_no.png": "2aba3",
	"./green/three/ken_yes.png": "2747",
	"./green/three/lev_no.png": "ad73",
	"./green/three/lev_yes.png": "6f46",
	"./green/three/ner_no.png": "7717",
	"./green/three/ner_yes.png": "7709",
	"./green/three/pe_no.png": "00b8",
	"./green/three/pe_yes.png": "28e1",
	"./green/three/yesh_no.png": "3a25",
	"./green/three/yesh_yes.png": "00d4",
	"./orange/five/avocado_no.png": "7f3e",
	"./orange/five/avocado_yes.png": "1814",
	"./orange/five/chagora_no.png": "6588",
	"./orange/five/chagora_yes.png": "ff06",
	"./orange/five/chatzotzra_no.png": "bd15",
	"./orange/five/chatzotzra_yes.png": "24c7",
	"./orange/five/matanot_no.png": "5bc3",
	"./orange/five/matanot_yes.png": "013a",
	"./orange/five/ofanaim_no.png": "04de",
	"./orange/five/ofanaim_yes.png": "9b7d",
	"./orange/five/ofanoa_no.png": "06f2",
	"./orange/five/ofanoa_yes.png": "8943",
	"./orange/five/paamon_no.png": "a2d2",
	"./orange/five/paamon_yes.png": "dd18",
	"./orange/five/shofar_no.png": "ef38",
	"./orange/five/shofar_yes.png": "ba25",
	"./orange/five/tolaat_no.png": "4a8a",
	"./orange/five/tolaat_yes.png": "8946",
	"./orange/five/traktor_no.png": "af32",
	"./orange/five/traktor_yes.png": "75c3",
	"./orange/four/balon_no.png": "123e",
	"./orange/four/balon_yes.png": "301f",
	"./orange/four/chalom_no.png": "8911",
	"./orange/four/chalom_yes.png": "44ea",
	"./orange/four/chamor_no.png": "57c6",
	"./orange/four/chamor_yes.png": "2ecd",
	"./orange/four/chayot_no.png": "aabc",
	"./orange/four/chayot_yes.png": "b109",
	"./orange/four/gadol_no.png": "2e7b",
	"./orange/four/gadol_yes.png": "fd4f",
	"./orange/four/halon_no.png": "1a18",
	"./orange/four/halon_yes.png": "e056",
	"./orange/four/kaftor_no.png": "e90c",
	"./orange/four/kaftor_yes.png": "b595",
	"./orange/four/katom_no.png": "526d",
	"./orange/four/katom_yes.png": "fe2e",
	"./orange/four/kochav_no.png": "3319",
	"./orange/four/kochav_yes.png": "4458",
	"./orange/four/kova_no.png": "f41d",
	"./orange/four/kova_yes.png": "0c85",
	"./orange/level_five.png": "8d0a",
	"./orange/level_five_hover.png": "f618",
	"./orange/level_five_lock.png": "8f18",
	"./orange/level_four.png": "1d0e",
	"./orange/level_four_hover.png": "a9ec",
	"./orange/level_four_lock.png": "41a9",
	"./orange/level_one.png": "bbae",
	"./orange/level_one_hover.png": "5180",
	"./orange/level_six.png": "45f20",
	"./orange/level_six_hover.png": "de3a",
	"./orange/level_six_lock.png": "6662",
	"./orange/level_three.png": "c960",
	"./orange/level_three_hover.png": "daae",
	"./orange/level_three_lock.png": "5beb",
	"./orange/level_two.png": "ecc0",
	"./orange/level_two_hover.png": "00bb",
	"./orange/level_two_lock.png": "0692",
	"./orange/one/O_1.png": "69ba",
	"./orange/one/O_1_correct.png": "c374",
	"./orange/one/O_2.png": "03b1",
	"./orange/one/O_2_correct.png": "2f20",
	"./orange/one/guide_pic.png": "bfa9",
	"./orange/six/ayom_yom_no.png": "db82",
	"./orange/six/ayom_yom_yes.png": "d2d4",
	"./orange/six/bamba_no.png": "df9d",
	"./orange/six/bamba_yes.png": "5d4a",
	"./orange/six/charak_katan_no.png": "e01d",
	"./orange/six/charak_katan_yes.png": "c931",
	"./orange/six/glida_vanil_no.png": "0995",
	"./orange/six/glida_vanil_yes.png": "5a4f",
	"./orange/six/rakdanit_balet_no.png": "57c6d",
	"./orange/six/rakdanit_balet_yes.png": "0ca6",
	"./orange/six/saba_tas_no.png": "b363",
	"./orange/six/saba_tas_yes.png": "dfdf",
	"./orange/three/chol_no.png": "a40c",
	"./orange/three/chol_yes.png": "0861",
	"./orange/three/dov_no.png": "f3fc",
	"./orange/three/dov_yes.png": "2a67",
	"./orange/three/hof_no.png": "416f",
	"./orange/three/hof_yes.png": "ab8c",
	"./orange/three/hom_no.png": "92b2",
	"./orange/three/hom_yes.png": "35ac",
	"./orange/three/kof_no.png": "cb55",
	"./orange/three/kof_yes.png": "637a",
	"./orange/three/kos_no.png": "0f3a",
	"./orange/three/kos_yes.png": "634e",
	"./orange/three/or_no.png": "da33",
	"./orange/three/or_yes.png": "8d31",
	"./orange/three/shor_no.png": "e52f",
	"./orange/three/shor_yes.png": "7bcd",
	"./orange/three/tof_no.png": "c945",
	"./orange/three/tof_yes.png": "57fd",
	"./orange/three/yom_no.png": "6577",
	"./orange/three/yom_yes.png": "e2dd",
	"./white/five/achbar_no.png": "ac85",
	"./white/five/achbar_yes.png": "159a",
	"./white/five/afsaka_no.png": "8ec8",
	"./white/five/afsaka_yes.png": "d488",
	"./white/five/aftaa_no.png": "a5c6",
	"./white/five/aftaa_yes.png": "1d47",
	"./white/five/agala_no.png": "72d6",
	"./white/five/agala_yes.png": "3569",
	"./white/five/ambatya_no.png": "21a6",
	"./white/five/ambatya_yes.png": "db6b",
	"./white/five/ashpa_no.png": "574d",
	"./white/five/ashpa_yes.png": "2f3a",
	"./white/five/atzaga_no.png": "44a2",
	"./white/five/atzaga_yes.png": "af13",
	"./white/five/azaka_no.png": "5184",
	"./white/five/azaka_yes.png": "de33",
	"./white/five/banana_no.png": "bede",
	"./white/five/banana_yes.png": "119f",
	"./white/five/barvaz_no.png": "dcc7",
	"./white/five/barvaz_yes.png": "c78f",
	"./white/five/galgal_no.png": "8e57",
	"./white/five/galgal_yes.png": "cf7b",
	"./white/five/maatafa_no.png": "71c0",
	"./white/five/maatafa_yes.png": "9eb5",
	"./white/five/machvat_no.png": "03c8",
	"./white/five/machvat_yes.png": "770e",
	"./white/five/mamtak_no.png": "9804",
	"./white/five/mamtak_yes.png": "7906",
	"./white/five/matana_no.png": "a96e",
	"./white/five/matana_yes.png": "ec0c",
	"./white/five/safsal_no.png": "ca6d",
	"./white/five/safsal_yes.png": "af9f",
	"./white/five/savta_no.png": "41a5",
	"./white/five/savta_yes.png": "1c19",
	"./white/five/tabaat_no.png": "a36d",
	"./white/five/tabaat_yes.png": "65d9",
	"./white/five/tzalachat_no.png": "6e37",
	"./white/five/tzalachat_yes.png": "31b0",
	"./white/four/aba_no.png": "6bc4",
	"./white/four/aba_yes.png": "f862",
	"./white/four/achal_no.png": "4bc6",
	"./white/four/achal_yes.png": "c020",
	"./white/four/agas_no.png": "a08d",
	"./white/four/agas_yes.png": "5e9f",
	"./white/four/akrav_no.png": "1803",
	"./white/four/akrav_yes.png": "731b",
	"./white/four/alach_no.png": "bed1",
	"./white/four/alach_yes.png": "129f",
	"./white/four/amar_no.png": "c08b",
	"./white/four/amar_yes.png": "f650",
	"./white/four/anan_no.png": "528c",
	"./white/four/anan_yes.png": "9c5c",
	"./white/four/avad_no.png": "185f",
	"./white/four/avad_yes.png": "9b92",
	"./white/four/bacha_no.png": "a040",
	"./white/four/bacha_yes.png": "c6b7",
	"./white/four/bana_no.png": "32d0",
	"./white/four/bana_yes.png": "1968",
	"./white/four/barach_no.png": "2b0b",
	"./white/four/barach_yes.png": "f5d2",
	"./white/four/chasa_no.png": "6b8d",
	"./white/four/chasa_yes.png": "1062",
	"./white/four/dahag_no.png": "4b51",
	"./white/four/dahag_yes.png": "fd88",
	"./white/four/ganan_no.png": "f6b5",
	"./white/four/ganan_yes.png": "4f31",
	"./white/four/hafra_no.png": "5ef7",
	"./white/four/hafra_yes.png": "1b58",
	"./white/four/kalmar_no.png": "c73c",
	"./white/four/kalmar_yes.png": "04ed",
	"./white/four/katan_no.png": "3896",
	"./white/four/katan_yes.png": "d5d9",
	"./white/four/katva_no.png": "35ed",
	"./white/four/katva_yes.png": "806b",
	"./white/four/layla_no.png": "1daf",
	"./white/four/layla_yes.png": "1244",
	"./white/four/nahash_no.png": "1064",
	"./white/four/nahash_yes.png": "a366",
	"./white/four/parpar_no.png": "f8ec",
	"./white/four/parpar_yes.png": "c5b2",
	"./white/four/saba_no.png": "a13d",
	"./white/four/saba_yes.png": "adff",
	"./white/four/sapar_no.png": "3822",
	"./white/four/sapar_yes.png": "a750",
	"./white/four/sartan_no.png": "3a56",
	"./white/four/sartan_yes.png": "16fc",
	"./white/four/shata_no.png": "b536",
	"./white/four/shata_yes.png": "01ac",
	"./white/four/tabach_no.png": "b291",
	"./white/four/tabach_yes.png": "5d06",
	"./white/four/yalda_no.png": "f830",
	"./white/four/yalda_yes.png": "3458",
	"./white/four/yashav_no.png": "0924",
	"./white/four/yashav_yes.png": "79b0",
	"./white/level_five.png": "729e",
	"./white/level_five_hover.png": "3aeb",
	"./white/level_five_lock.png": "b8f3",
	"./white/level_four.png": "8617",
	"./white/level_four_hover.png": "ce3d",
	"./white/level_four_lock.png": "e093",
	"./white/level_one.png": "97ec",
	"./white/level_one_hover.png": "8b20",
	"./white/level_six.png": "c603",
	"./white/level_six_hover.png": "9c3d",
	"./white/level_six_lock.png": "ab69",
	"./white/level_three.png": "a249",
	"./white/level_three_hover.png": "76a3",
	"./white/level_three_lock.png": "59d7",
	"./white/level_two.png": "aeb4",
	"./white/level_two_hover.png": "6f04",
	"./white/level_two_lock.png": "d8a2",
	"./white/one/A_1.png": "2a6d",
	"./white/one/A_1_correct.png": "d62a",
	"./white/one/A_2.png": "45e5",
	"./white/one/A_2_correct.png": "da93",
	"./white/one/A_3.png": "55fc",
	"./white/one/A_3_correct.png": "9992",
	"./white/one/Shva.png": "5c29",
	"./white/one/Shva_correct.png": "50b1",
	"./white/one/guide_pic.png": "5b22",
	"./white/one/guide_pic_whiteB.png": "7cd4",
	"./white/six/aba_daag_no.png": "7953",
	"./white/six/aba_daag_yes.png": "ae3a",
	"./white/six/aba_darach_no.png": "e031",
	"./white/six/aba_darach_yes.png": "aa79",
	"./white/six/aba_shata_no.png": "a795",
	"./white/six/aba_shata_yes.png": "7a4a",
	"./white/six/ayalda_anda_no.png": "1a57",
	"./white/six/ayalda_anda_yes.png": "d845",
	"./white/six/parpar_no.png": "196e",
	"./white/six/parpar_yes.png": "9a21",
	"./white/six/saba_achal_no.png": "db59",
	"./white/six/saba_achal_yes.png": "f926",
	"./white/six/saba_aya_no.png": "d13e",
	"./white/six/saba_aya_yes.png": "cebc",
	"./white/six/saba_maatafa_no.png": "d675",
	"./white/six/saba_maatafa_yes.png": "3303",
	"./white/six/saba_matza_no.png": "a89b",
	"./white/six/saba_matza_yes.png": "15d0",
	"./white/six/saba_safsal_no.png": "5819",
	"./white/six/saba_safsal_yes.png": "8c72",
	"./white/six/yalda_afsaka_no.png": "814d",
	"./white/six/yalda_afsaka_yes.png": "d27f",
	"./white/six/yalda_nemala_no.png": "7f96",
	"./white/six/yalda_nemala_yes.png": "4f7e",
	"./white/three/ach_no.png": "2132",
	"./white/three/ach_yes.png": "289e",
	"./white/three/af_no.png": "1e5b",
	"./white/three/af_yes.png": "92a5",
	"./white/three/bat_no.png": "d66e",
	"./white/three/bat_yes.png": "5550",
	"./white/three/cham_no.png": "ce96",
	"./white/three/cham_yes.png": "9e00",
	"./white/three/dag_no.png": "d2e6",
	"./white/three/dag_yes.png": "56de",
	"./white/three/gal_no.png": "a53d",
	"./white/three/gal_yes.png": "9689",
	"./white/three/gan_no.png": "3615",
	"./white/three/gan_yes.png": "070f",
	"./white/three/har_no.png": "5806",
	"./white/three/har_yes.png": "d54d",
	"./white/three/hav_no.png": "2fb9",
	"./white/three/hav_yes.png": "8341",
	"./white/three/kaf_no.png": "5aad",
	"./white/three/kaf_yes.png": "f7db",
	"./white/three/kar_no.png": "1a5f",
	"./white/three/kar_yes.png": "4e4b",
	"./white/three/kav_no.png": "1c6d",
	"./white/three/kav_yes.png": "7d8c",
	"./white/three/pach_no.png": "aa53",
	"./white/three/pach_yes.png": "4ad2",
	"./white/three/sal_no.png": "edf4",
	"./white/three/sal_yes.png": "de57",
	"./white/three/shar_no.png": "0c0e",
	"./white/three/shar_yes.png": "372e",
	"./white/three/shay_no.png": "04a8",
	"./white/three/shay_yes.png": "146e",
	"./white/three/tas_no.png": "8902",
	"./white/three/tas_yes.png": "7395",
	"./white/three/tzav_no.png": "9be3",
	"./white/three/tzav_yes.png": "83fd",
	"./white/three/yad_no.png": "7792",
	"./white/three/yad_yes.png": "d92c",
	"./white/three/yam_no.png": "f5de",
	"./white/three/yam_yes.png": "6194",
	"./yellow/five/agvania_no.png": "a4bc",
	"./yellow/five/agvania_yes.png": "0b1d",
	"./yellow/five/avatiach_no.png": "8e67",
	"./yellow/five/avatiach_yes.png": "ee65",
	"./yellow/five/chalalit_no.png": "14ba",
	"./yellow/five/chalalit_yes.png": "33d4",
	"./yellow/five/lachmania_no.png": "d663",
	"./yellow/five/lachmania_yes.png": "4329",
	"./yellow/five/magafaim_no.png": "1dd0",
	"./yellow/five/magafaim_yes.png": "001d",
	"./yellow/five/masait_no.png": "d3d0",
	"./yellow/five/masait_yes.png": "d7a4",
	"./yellow/five/mischakim_no.png": "16b3",
	"./yellow/five/mischakim_yes.png": "aa4d",
	"./yellow/five/mishkafaim_no.png": "3384",
	"./yellow/five/mishkafaim_yes.png": "912a",
	"./yellow/five/misparaim_no.png": "5352",
	"./yellow/five/misparaim_yes.png": "3648",
	"./yellow/five/naalaim_no.png": "e633",
	"./yellow/five/naalaim_yes.png": "6d2e",
	"./yellow/four/bait_no.png": "c592",
	"./yellow/four/bait_yes.png": "aafb",
	"./yellow/four/hima_no.png": "27c4",
	"./yellow/four/hima_yes.png": "46a7",
	"./yellow/four/kaitz_no.png": "8303",
	"./yellow/four/kaitz_yes.png": "611d",
	"./yellow/four/kita_no.png": "2af1",
	"./yellow/four/kita_yes.png": "a8a0",
	"./yellow/four/maim_no.png": "ae19",
	"./yellow/four/maim_yes.png": "42d2",
	"./yellow/four/mita_no.png": "252b",
	"./yellow/four/mita_yes.png": "55df",
	"./yellow/four/mitbach_no.png": "0c0b",
	"./yellow/four/mitbach_yes.png": "836c",
	"./yellow/four/pitria_no.png": "44dd",
	"./yellow/four/pitria_yes.png": "5685",
	"./yellow/four/sira_no.png": "9e02",
	"./yellow/four/sira_yes.png": "149d",
	"./yellow/four/talmid_no.png": "ce72",
	"./yellow/four/talmid_yes.png": "aef4",
	"./yellow/level_five.png": "1b5c",
	"./yellow/level_five_hover.png": "aac6",
	"./yellow/level_five_lock.png": "9bae",
	"./yellow/level_four.png": "6819",
	"./yellow/level_four_hover.png": "d6a2",
	"./yellow/level_four_lock.png": "fd43",
	"./yellow/level_one.png": "1a00",
	"./yellow/level_one_hover.png": "0f47",
	"./yellow/level_six.png": "a6e8",
	"./yellow/level_six_hover.png": "cba7",
	"./yellow/level_six_lock.png": "7d8a",
	"./yellow/level_three.png": "4b87",
	"./yellow/level_three_hover.png": "bbcd",
	"./yellow/level_three_lock.png": "c14d",
	"./yellow/level_two.png": "d8f0",
	"./yellow/level_two_hover.png": "430f",
	"./yellow/level_two_lock.png": "cfb8",
	"./yellow/one/I_1.png": "abc4",
	"./yellow/one/I_1_correct.png": "8a77",
	"./yellow/one/I_2.png": "cc67",
	"./yellow/one/I_2_correct.png": "8112",
	"./yellow/one/guide_pic.png": "ffbb",
	"./yellow/six/aarie_beleaka_no.png": "12ab",
	"./yellow/six/aarie_beleaka_yes.png": "e084",
	"./yellow/six/adi_achla_kartiv_no.png": "0f2d",
	"./yellow/six/adi_achla_kartiv_yes.png": "b05e",
	"./yellow/six/letaa_al_ayad_no.png": "4d2c",
	"./yellow/six/letaa_al_ayad_yes.png": "fd6a",
	"./yellow/six/sichakti_bagan_no.png": "b4f6",
	"./yellow/six/sichakti_bagan_yes.png": "f975",
	"./yellow/six/yalda_yafa_no.png": "c4b4",
	"./yellow/six/yalda_yafa_yes.png": "9a35",
	"./yellow/three/bis_no.png": "e8b3",
	"./yellow/three/bis_yes.png": "8f9f",
	"./yellow/three/hir_no.png": "a910",
	"./yellow/three/hir_yes.png": "e52a",
	"./yellow/three/kir_no.png": "96c5",
	"./yellow/three/kir_yes.png": "8b97",
	"./yellow/three/kis_no.png": "6c21",
	"./yellow/three/kis_yes.png": "d053",
	"./yellow/three/mitz_no.png": "e760",
	"./yellow/three/mitz_yes.png": "1ba2",
	"./yellow/three/pil_no.png": "6519",
	"./yellow/three/pil_yes.png": "3739",
	"./yellow/three/shir_no.png": "aed7",
	"./yellow/three/shir_yes.png": "83bc",
	"./yellow/three/sir_no.png": "dcec",
	"./yellow/three/sir_yes.png": "8d8f",
	"./yellow/three/tik_no.png": "f545",
	"./yellow/three/tik_yes.png": "3c6c",
	"./yellow/three/til_no.png": "01f4",
	"./yellow/three/til_yes.png": "9b03"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8a09";